document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (menu && nav) {
    menu.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      menu.setAttribute('aria-expanded', String(open));
      menu.textContent = open ? '✕' : '☰';
    });
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { nav.classList.remove('open'); menu.textContent = '☰'; menu.setAttribute('aria-expanded','false'); }));
  }
  const intro = document.querySelector('[data-intro]');
  document.querySelector('[data-intro-skip]')?.addEventListener('click', () => intro?.remove());
  if (intro) setTimeout(() => intro.remove(), 8500);
  let shape = 'Rectangle';
  const length = document.querySelector('[data-length]');
  const width = document.querySelector('[data-width]');
  const area = document.querySelector('[data-area]');
  const update = () => { if (!length || !width || !area) return; const factor = shape === 'Circle' ? .785 : shape === 'L-Shape' ? .75 : 1; area.textContent = Math.round((Number(length.value)||0)*(Number(width.value)||0)*factor).toLocaleString(); };
  document.querySelectorAll('[data-shape]').forEach(button => button.addEventListener('click', () => { shape = button.dataset.shape; document.querySelectorAll('[data-shape]').forEach(b => b.classList.toggle('active', b === button)); update(); }));
  length?.addEventListener('input', update); width?.addEventListener('input', update); update();

  document.querySelectorAll('.section .wrap, .trust-grid, .project-heading, .footer-cta').forEach(el => el.classList.add('reveal-ready'));
  const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('revealed'); revealObserver.unobserve(entry.target); }
  }), { threshold: .12 });
  document.querySelectorAll('.reveal-ready').forEach(el => revealObserver.observe(el));

  const chat = document.querySelector('[data-chat-widget]');
  const panel = document.querySelector('[data-chat-panel]');
  const chatInput = document.querySelector('[data-chat-form] input');
  const messages = document.querySelector('[data-chat-messages]');
  const prompts = document.querySelector('[data-chat-prompts]');
  const form = document.querySelector('[data-chat-form]');
  const submit = form?.querySelector('button');
  const status = document.querySelector('[data-chat-status]');
  const endpoint = chat?.dataset.chatEndpoint?.trim();
  const setChat = open => { chat?.classList.toggle('open', open); panel?.setAttribute('aria-hidden', String(!open)); if (open) setTimeout(() => chatInput?.focus(), 250); };
  document.querySelector('[data-chat-open]')?.addEventListener('click', () => setChat(!chat?.classList.contains('open')));
  document.querySelector('[data-chat-close]')?.addEventListener('click', () => setChat(false));
  const addMessage = (role, text, extra = '') => { const bubble = document.createElement('div'); bubble.className = `chat-message ${role} ${extra}`.trim(); bubble.textContent = text; messages?.appendChild(bubble); if (messages) messages.scrollTop = messages.scrollHeight; return bubble; };
  const sendChat = async raw => {
    const text = raw?.trim(); if (!text || !endpoint || !messages) return;
    addMessage('user', text); chatInput.value = ''; prompts?.remove();
    const typing = addMessage('assistant', '•••', 'typing'); submit.disabled = true; status?.classList.remove('error');
    try {
      const url = new URL(endpoint); url.searchParams.set('q', text);
      const response = await fetch(url.toString()); const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || `Request failed (${response.status})`);
      typing.remove(); addMessage('assistant', data.reply || 'Please call Wes at 941-492-2424 for help.');
    } catch (error) {
      typing.remove(); addMessage('assistant', 'I’m having trouble connecting right now. Please call Wes at 941-492-2424.');
      if (status) { status.textContent = 'Connection unavailable • Please try again'; status.classList.add('error'); }
    } finally { submit.disabled = false; chatInput?.focus(); }
  };
  document.querySelectorAll('[data-chat-prompt]').forEach(button => button.addEventListener('click', () => sendChat(button.textContent)));
  form?.addEventListener('submit', event => { event.preventDefault(); sendChat(chatInput?.value); });

  const projectLoop = document.querySelector('[data-project-loop]');
  if (projectLoop && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const originals = [...projectLoop.children];
    originals.forEach(card => { const clone = card.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); projectLoop.appendChild(clone); });
    const loopDistance = projectLoop.children[originals.length].offsetLeft - projectLoop.children[0].offsetLeft;
    let paused = false;
    let position = projectLoop.scrollLeft;
    let previousTime = performance.now();
    const animateProjects = time => {
      if (!paused) position += Math.min(1.5, (time - previousTime) * 0.045);
      if (position >= loopDistance) position -= loopDistance;
      projectLoop.scrollLeft = position;
      previousTime = time;
      requestAnimationFrame(animateProjects);
    };
    projectLoop.addEventListener('mouseenter', () => { paused = true; });
    projectLoop.addEventListener('mouseleave', () => { paused = false; });
    projectLoop.addEventListener('focusin', () => { paused = true; });
    projectLoop.addEventListener('focusout', () => { paused = false; });
    projectLoop.addEventListener('touchstart', () => { paused = true; position = projectLoop.scrollLeft; }, { passive: true });
    projectLoop.addEventListener('touchend', () => { position = projectLoop.scrollLeft; window.setTimeout(() => { paused = false; }, 1200); }, { passive: true });
    requestAnimationFrame(animateProjects);
  }
});
